module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE")]), _vm._v("-M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INNEAPOLIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1#S1"
    }
  }, [_vm._v("The Last Scalp Dance on the Land of Minneapolis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1#S2"
    }
  }, [_vm._v("Man of the Sky’s Decline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1#S3"
    }
  }, [_vm._v("A “Sort of Frenzy”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INNEAPOLIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2#S4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cold(-Hearted) June")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2#S5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escape from Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2#S6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bridge Square Fires")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATANIC")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part3#S7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Falls Collapse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part3#S8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mill Explosion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOLENCE IN THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part4#S9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Means Unknown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part4#S10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Family that Slays Together")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part4#S11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Streetcar Strike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Part4#S12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midnight Assassination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0